import React from 'react'
import PropTypes from 'prop-types'

const HorizontalLayout = ({ children }) => {
  return (
    <div id="layout-wrapper">
      <div className="main-content">
        {children}
      </div>
    </div>
  )
}

HorizontalLayout.propTypes = {
  children: PropTypes.node,
}

export default HorizontalLayout
